import { core_v1_DataSource, core_v1_Rule } from '@antimatterhq/asl-api-ts-v1';

export const DATADOG_MESSAGE = {
  DATASOURCE: {
    CREATE: {
      STEP: {
        SUCCESS: 'datasource.create.step.success',
        FAILURE: 'datasource.create.step.failure',
      },
      COMPLETE: {
        SUCCESS: 'datasource.create.complete.success',
        FAILURE: 'datasource.create.complete.failure',
      },
    },
    UPDATE: {
      STEP: {
        SUCCESS: 'datasource.update.step.success',
        FAILURE: 'datasource.update.step.failure',
      },
      COMPLETE: {
        SUCCESS: 'datasource.update.complete.success',
        FAILURE: 'datasource.update.complete.failure',
      },
    },
    ADD: 'datasource.add',
  },
  DETECTION_RULE: {
    CREATE: {
      SUCCESS: 'detectionRule.create.success',
      FAILURE: 'detectionRule.create.failure',
    },
    UPDATE: {
      SUCCESS: 'detectionRule.update.success',
      FAILURE: 'detectionRule.update.failure',
    },
  },
};

export const getDatadogPreset = ({
  source,
  sourceType,
}: {
  source?: string | null;
  sourceType?: string | null;
}) => {
  return {
    dataPreset: {
      source: source || '',
      sourceType: sourceType || '',
    },
  };
};

export const getDatadogDatasource = (datasource: core_v1_DataSource) => {
  const { spec, metadata } = datasource;
  return {
    datasource: { spec, metadata },
  };
};

export const getDatadogDetectionRule = (rule: core_v1_Rule) => {
  const { spec, metadata } = rule;
  return {
    detectionRule: { spec, metadata },
  };
};
